/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Port } from './Port';
import {
    PortFromJSON,
    PortFromJSONTyped,
    PortToJSON,
} from './Port';

/**
 * 
 * @export
 * @interface CRSFSecReviewTech
 */
export interface CRSFSecReviewTech {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewTech
     */
    asset: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewTech
     */
    category: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewTech
     */
    cves?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CRSFSecReviewTech
     */
    data: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewTech
     */
    found: number;
    /**
     * 
     * @type {Port}
     * @memberof CRSFSecReviewTech
     */
    port?: Port;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewTech
     */
    protocol?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewTech
     */
    shared?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewTech
     */
    source_asset?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewTech
     */
    tech_name: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewTech
     */
    updated: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewTech
     */
    version?: string;
}

/**
 * Check if a given object implements the CRSFSecReviewTech interface.
 */
export function instanceOfCRSFSecReviewTech(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "found" in value;
    isInstance = isInstance && "tech_name" in value;
    isInstance = isInstance && "updated" in value;

    return isInstance;
}

export function CRSFSecReviewTechFromJSON(json: any): CRSFSecReviewTech {
    return CRSFSecReviewTechFromJSONTyped(json, false);
}

export function CRSFSecReviewTechFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewTech {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'category': json['category'],
        'cves': !exists(json, 'cves') ? undefined : json['cves'],
        'data': json['data'],
        'found': json['found'],
        'port': !exists(json, 'port') ? undefined : PortFromJSON(json['port']),
        'protocol': !exists(json, 'protocol') ? undefined : json['protocol'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'source_asset': !exists(json, 'source_asset') ? undefined : json['source_asset'],
        'tech_name': json['tech_name'],
        'updated': json['updated'],
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}

export function CRSFSecReviewTechToJSON(value?: CRSFSecReviewTech | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'category': value.category,
        'cves': value.cves,
        'data': value.data,
        'found': value.found,
        'port': PortToJSON(value.port),
        'protocol': value.protocol,
        'shared': value.shared,
        'source_asset': value.source_asset,
        'tech_name': value.tech_name,
        'updated': value.updated,
        'version': value.version,
    };
}

